
export default class Faqs {

	static getHolderSelectors = () => ['.faqs-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;

		this.#holderElement.querySelectorAll('.question').forEach(question => {
			question.addEventListener("click", (event)=>{
				this.#holderElement.querySelectorAll('.question').forEach(questionItem => {
					questionItem.classList.add('collapsed');
				});
				this.#holderElement.querySelectorAll('.answer').forEach(answer => {
					answer.classList.remove('show');
				});
				question.classList.remove('collapsed');
				if (question.getAttribute('aria-expanded') === 'false') {
					question.classList.add('collapsed');
				}
			});
		})
	}

}
